module.exports = __webpack_public_path__ + "img/2.e86cb783.jpg";